import { withRouter } from 'react-router-dom';

import { useActiveForm } from '@/components/form/ActiveSwitch';
import { useAppAlert } from '@Components/AppAlert';
import FormWrapper from '@Components/form/Wrapper';
import history from 'utils/history';

import Form from '../components/Form';
import Heading from '../components/Heading';
import { PixelProvider, usePixelStore } from '../store';

const PixelForm = withRouter(({ match: { params: { id } } }) => {
  const { collection: { item, useLoad, useSubmit } } = usePixelStore()
  const { handleSuccess, handleError } = useAppAlert()
  const { active, setActive } = useActiveForm(item)

  useLoad(id)
  const handleSubmit = useSubmit()

  const handleSubmitAndClose = async payload => {
    try {
      await handleSubmit({ ...payload, active })
      const message = payload.id ? 'edited' : 'created'
      history.push(`/path/pixels`);
      handleSuccess('Success', `Pixel ${message}.`)
    } catch {
      handleError('Error', 'Pixel was not saved.')
    }
    history.push(`/path/pixels`);
  }

  if (!item) {
    return null
  }

  return <>
    <FormWrapper title="Pixel" >
      <Heading data={item} active={active} onChangeActive={setActive} />
      <Form data={item} handleSubmit={handleSubmitAndClose} />
    </FormWrapper>
  </>
});

export default function PixelFormLayout() {
  return <PixelProvider>
    <PixelForm />
  </PixelProvider>
}
